<template>
    <div class="operator-interface">
        <header class="operator-header">
            <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button"/>
            <div class="header-copy">
                <h2>Interfaz de operador</h2>
                <p>Gestiona tus servicios asignados</p>
            </div>
        </header>

        <section class="welcome-and-logout">
            <div class="welcome-text">
                <h3>Bienvenido/a, {{ firstName }}</h3>
                <p>Revisa el detalle de cada servicio para continuar.</p>
            </div>
            <div class="action-buttons">
                <button v-if="isRemote" class="btn btn-secondary" @click="goToAttendance">Asistencia</button>
                <button class="btn btn-secondary" @click="goToCommissions">Ver mis comisiones</button>
                <button class="btn btn-secondary" @click="goToIncidents">Ver mis incidencias</button>
                <button class="btn btn-danger" @click="logout">Cerrar sesión</button>
            </div>
        </section>

        <section class="mobile-assignations">
            <article
                v-for="(assignation, index) in paginatedOrders"
                :key="index"
                class="assignation-card"
                @click="navigateToOrderDetails(assignation.id)"
            >
                <div class="card-top">
                    <span class="id-span">
                        #{{ assignation.assistance_note.note_number }}
                    </span>
                    <span class="note-type">{{ formatServiceType(assignation.assistance_note_type) }}</span>
                </div>

                <div class="card-owner">
                    {{ assignation.assistance_note.vehicle_owner_name }}
                </div>

                <div class="route-strip">
                    <div class="route-point">
                        <span class="route-label">Origen</span>
                        <span class="route-text">{{ assignation.assistance_note.source.city }}, {{ assignation.assistance_note.source.state }}</span>
                    </div>
                    <span class="route-arrow">→</span>
                    <div class="route-point">
                        <span class="route-label">Destino</span>
                        <span class="route-text">{{ assignation.assistance_note.destination.city }}, {{ assignation.assistance_note.destination.state }}</span>
                    </div>
                </div>

                <div class="mini-meta">
                    <span><b>Marca:</b> {{ assignation.assistance_note_brand }}</span>
                    <span><b>Placas:</b> {{ assignation.assistance_note.vehicle_plates }}</span>
                </div>
            </article>
        </section>

        <section class="table-container-operator">
            <table class="table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Asegurado</th>
                        <th>Origen</th>
                        <th>Destino</th>
                        <th>Tipo de nota</th>
                        <th>Datos del vehículo</th>
                        <th>Referencias de origen</th>
                        <th>Referencias de destino</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(assignation, index) in paginatedOrders" :key="index">
                        <td @click="navigateToOrderDetails(assignation.id)">
                            <span class="id-span">#{{ assignation.assistance_note.note_number }}</span>
                        </td>
                        <td>{{ assignation.assistance_note.vehicle_owner_name }}</td>
                        <td><b>Calle: </b>{{ assignation.assistance_note.source.street_name }}<br> <b>Número: </b>{{ assignation.assistance_note.source.number }}<br> <b>Entre calles: </b>{{ assignation.assistance_note.source.between_streets }}<br> <b>Colonia: </b>{{ assignation.assistance_note.source.neighborhood }}<br> <b>Ciudad: </b>{{ assignation.assistance_note.source.city }}<br> <b>Estado: </b>{{ assignation.assistance_note.source.state }}</td>
                        <td><b>Calle: </b>{{ assignation.assistance_note.destination.street_name }}<br> <b>Número: </b>{{ assignation.assistance_note.destination.number }}<br> <b>Entre calles: </b>{{ assignation.assistance_note.destination.between_streets }}<br> <b>Colonia: </b>{{ assignation.assistance_note.destination.neighborhood }}<br> <b>Ciudad: </b>{{ assignation.assistance_note.destination.city }}<br> <b>Estado: </b>{{ assignation.assistance_note.destination.state }}</td>
                        <td>{{ formatServiceType(assignation.assistance_note_type) }}</td>
                        <td><b>Marca: </b>{{ assignation.assistance_note_brand }}<br><b>Submarca: </b>{{ assignation.assistance_note_subbrand }}<br><b>Color: </b>{{ assignation.assistance_note.vehicle_color }}<br><b>Placas: </b>{{ assignation.assistance_note.vehicle_plates }}<br></td>
                        <td><b>Referencias: </b>{{ assignation.assistance_note.source_notes }}<br></td>
                        <td><b>Referencias: </b>{{ assignation.assistance_note.destination_notes }}<br></td>
                    </tr>
                </tbody>
            </table>
        </section>

        <div class="pagination-container">
            <button @click="prevPage" :disabled="currentPage === 1">
                <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
            </button>
            <span>Página {{ currentPage }} de {{ totalPages }}</span>
            <button @click="nextPage" :disabled="currentPage >= totalPages">
                <img src="@/assets/angulo-derecho.png" alt="Next Page" />
            </button>
        </div>
    </div>
</template>

<style scoped>
.operator-interface {
    min-height: 100vh;
    padding: 12px 12px 22px;
    background: linear-gradient(180deg, #fff7df 0%, #fff 26%);
    color: #1a1a1a;
}

.operator-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border-radius: 16px;
    background: #ffc434;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.logo-button {
    position: static !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    display: block;
    width: 70px;
    height: 70px;
    object-fit: contain;
    background: #fff;
    border-radius: 14px;
    padding: 8px;
}

.header-copy h2 {
    margin: 0;
    font-size: 1.2rem;
}

.header-copy p {
    margin: 3px 0 0;
    font-size: 0.85rem;
    opacity: 0.8;
}

.welcome-and-logout {
    margin-top: 12px;
    padding: 12px;
    border-radius: 14px;
    background: #ffffff;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
}

.welcome-text h3 {
    margin: 0;
    font-size: 1rem;
}

.welcome-text p {
    margin: 6px 0 0;
    font-size: 0.84rem;
    color: #64748b;
}

.action-buttons {
    margin-top: 12px;
    display: grid;
    gap: 8px;
}

.btn {
    border: none;
    border-radius: 10px;
    padding: 10px 12px;
    font-weight: 600;
    font-size: 0.88rem;
    cursor: pointer;
}

.btn-secondary {
    background: #fff4d2;
    color: #1e293b;
    border: 1px solid #d4a62a;
}

.btn-danger {
    background: #ef4444;
    color: #fff;
}

.mobile-assignations {
    margin-top: 14px;
    display: grid;
    gap: 10px;
}

.assignation-card {
    background: linear-gradient(145deg, #ffffff 0%, #fff6d9 100%);
    border-radius: 14px;
    padding: 10px;
    box-shadow: 0 10px 22px rgba(255, 196, 52, 0.25), 0 6px 12px rgba(15, 23, 42, 0.08);
    border: 1px solid #d4a62a;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.assignation-card:active {
    transform: scale(0.99);
}

.assignation-card:hover {
    box-shadow: 0 14px 24px rgba(15, 23, 42, 0.12);
}

.card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.id-span {
    background-color: #ffc434;
    color: black;
    font-weight: bold;
    font-size: 0.78rem;
    padding: 4px 9px;
    border-radius: 999px;
}

.note-type {
    background: #0f172a;
    color: #fff;
    font-weight: 600;
    letter-spacing: 0.02em;
    max-width: 60%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: none;
    font-size: 0.72rem;
    border-radius: 999px;
    padding: 4px 8px;
}

.card-owner {
    font-weight: 700;
    font-size: 0.88rem;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.route-strip {
    margin-top: 7px;
    padding: 7px 8px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #d8b24c;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 6px;
    align-items: center;
}

.route-point {
    min-width: 0;
}

.route-label {
    display: block;
    font-size: 0.65rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.route-text {
    display: block;
    font-size: 0.73rem;
    color: #0f172a;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.route-arrow {
    color: #ca8a04;
    font-weight: 800;
    font-size: 0.95rem;
}

.mini-meta {
    margin-top: 6px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
}

.mini-meta span {
    font-size: 0.72rem;
    color: #334155;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid #ddbf66;
    border-radius: 8px;
    padding: 4px 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-row {
    margin-bottom: 8px;
}

.label {
    display: block;
    font-size: 0.75rem;
    letter-spacing: 0.04em;
    color: #64748b;
    text-transform: uppercase;
}

.card-section {
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid #f1f5f9;
}

.card-section h4 {
    margin: 0 0 7px;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #64748b;
}

.card-section p {
    margin: 2px 0;
    font-size: 0.82rem;
    line-height: 1.35;
    color: #334155;
}

.table-container-operator {
    display: none;
    margin-top: 14px;
    overflow-x: auto;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.1);
}

.table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 960px;
}

.table th,
.table td {
    border-bottom: 1px solid #e2e8f0;
    padding: 11px;
    text-align: left;
    font-size: 0.85rem;
    vertical-align: top;
}

.table th {
    background: #f8fafc;
    color: #334155;
    font-weight: 700;
    position: sticky;
    top: 0;
    z-index: 1;
}

.table tbody tr:hover td {
    background: #f8fafc;
}

.pagination-container {
    margin-top: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #fff;
    border-radius: 12px;
    padding: 8px;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
}

.pagination-container button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    border-radius: 10px;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-container button:disabled {
    opacity: 0.35;
    cursor: not-allowed;
}

.pagination-container span {
    font-size: 0.9rem;
    font-weight: 600;
}

.pagination-container button img {
    width: 24px;
    height: auto;
}

@media (min-width: 768px) {
    .operator-interface {
        padding: 18px 20px 28px;
    }

    .welcome-and-logout {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
    }

    .action-buttons {
        margin-top: 0;
        min-width: 240px;
    }
}

@media (min-width: 1024px) {
    .mobile-assignations {
        display: none;
    }

    .table-container-operator {
        display: block;
    }
}
</style>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            assignations: [],
            username: '',
            firstName: '',
            lastName: '',
            isRemote: false,
        };
    },
    computed: {
        paginatedOrders() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.assignations.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.assignations.length / this.pageSize);
        }
    },
    mounted() {
        this.fetchAssignations();
        this.fetchCurrentUser();
    },
    methods:{
        toggleFilterMenu() {
            this.showFilterMenu = !this.showFilterMenu;
        },
        applyFilters() {
            console.log('Filtros aplicados:', this.selectedFilters);
            this.showFilterMenu = false; 
        },
        nextPage() {
            if (this.currentPage < this.totalPages) this.currentPage++;
        },
        prevPage() {
            if (this.currentPage > 1) this.currentPage--;
        },
        formatServiceType(serviceType) {
            if (!serviceType) return serviceType;
            return serviceType.toLowerCase() === 'asistencia víal' ? 'Remolque' : serviceType;
        },
        async fetchAssignations() {
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.get(`${apiDirectory}/get-assignations-operator`, {
                    headers: {
                        'Authorization': `Token ${localStorage.getItem('authToken')}` 
                    }
                });
                 this.assignations = response.data
                 .filter(assignation => assignation.assistance_note !== null)
                 .sort((a, b) => b.id - a.id);
            } catch (error) {
                console.error('Failed to fetch assignations:', error);
            }
        },
        navigateToOrderDetails(assignation_id) {
            this.$router.push({ name: 'EditAssignation', params: { assignation_id } });
        },
        fetchCurrentUser() {
            const apiDirectory = process.env.API_DIRECTORY;
            axios.get(`${apiDirectory}/current-user/`, {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('authToken')
                }
            })
            .then(response => {
                this.username = response.data.username;
                this.firstName = response.data.first_name;
                this.lastName = response.data.last_name;
                this.groups = response.data.groups;
                this.isRemote = !!response.data.is_remote;
            })
            .catch(error => {
                console.error('There was an error fetching the user data:', error);
            });
        },
        logout() {
            // Also flush the Django session cookie (OAuth consent flow).
            axios.post(`${process.env.API_DIRECTORY}/logout/`).catch(() => {});
            // Clear the token from the Vuex store
            this.$store.commit('setToken', null);
            // Remove the token from local storage
            localStorage.removeItem('authToken');
            // Redirect to the login page
            this.$router.push({ name: 'UserLogin' });
        },
        goToAttendance() {
            this.$router.push({ name: 'OperatorAttendance' });
        },
        goToCommissions() {
            this.$router.push({ name: 'OperatorCommissions' });
        },
        goToIncidents() {
            this.$router.push({ name: 'MyIncidents' });
        }
    }
}
</script>